var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pa-6 ",style:('overflow: auto; height: calc(100vh - 225px)'),attrs:{"fluid":""}},[_c('DatatableV2',{attrs:{"displayTitle":false,"flat":false,"url":_vm.apiUrl}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }